/* KiiP homepage sections (split from the single KiiP homepage section, Oct 2026). */
(() => {
  /* Each section renders this script tag; run only once. */
  if (window.__kiipHome) return;
  window.__kiipHome = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero slideshow */
  function initHero(hero) {
    const slides = [...hero.querySelectorAll('.slide')], htabs = [...hero.querySelectorAll('.htab')];
    if (!slides.length) return;
    const DUR = (parseFloat(hero.dataset.duration) || 6.5) * 1000;
    hero.style.setProperty('--dur', DUR / 1000 + 's');
    let cur = 0, timer = null;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, j) => { s.classList.toggle('is-active', j === cur); s.setAttribute('aria-hidden', j !== cur); });
      htabs.forEach((t, j) => {
        t.classList.toggle('is-active', j === cur); t.classList.toggle('is-done', j < cur); t.setAttribute('aria-selected', j === cur);
        const bar = t.querySelector('i'); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
      });
      schedule();
    }
    function schedule() { clearTimeout(timer); if (reduce || slides.length < 2 || hero.classList.contains('is-paused')) return; timer = setTimeout(() => go(cur + 1), DUR); }
    htabs.forEach((t, j) => t.addEventListener('click', () => go(j)));
    const prev = hero.querySelector('[data-kh-prev]'), next = hero.querySelector('[data-kh-next]');
    if (prev) prev.onclick = () => go(cur - 1);
    if (next) next.onclick = () => go(cur + 1);
    const stage = hero.querySelector('.hero__stage');
    stage.addEventListener('mouseenter', () => { hero.classList.add('is-paused'); clearTimeout(timer); });
    stage.addEventListener('mouseleave', () => { hero.classList.remove('is-paused'); schedule(); });
    let tx = null;
    stage.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', e => { if (tx === null) return; const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); tx = null; });
    hero.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
    if (reduce) htabs.forEach(t => t.querySelector('i').style.width = '0');
    hero._khGo = go;
    schedule();
  }

  /* Tabbed product rail + quick view */
  function initProducts(root) {
    const rails = [...root.querySelectorAll('.rail')];
    const prog = root.querySelector('[data-kh-prog]'), rPrev = root.querySelector('[data-kh-rprev]'), rNext = root.querySelector('[data-kh-rnext]');
    let rail = rails.find(r => !r.hidden) || rails[0];
    if (!rail) return;
    function updRail() {
      if (!prog) return;
      const max = rail.scrollWidth - rail.clientWidth, ratio = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
      prog.style.width = (ratio * 100) + '%';
      prog.style.transform = `translateX(${max > 0 ? (rail.scrollLeft / max) * ((1 - ratio) / ratio) * 100 : 0}%)`;
      rPrev.disabled = rail.scrollLeft < 4; rNext.disabled = rail.scrollLeft > max - 4;
    }
    rails.forEach(r => r.addEventListener('scroll', () => requestAnimationFrame(updRail), { passive: true }));
    addEventListener('resize', updRail);
    const step = () => { const c = rail.querySelector('.card'); return c ? c.getBoundingClientRect().width + 16 : 300; };
    if (rPrev) rPrev.onclick = () => rail.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' });
    if (rNext) rNext.onclick = () => rail.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' });
    let drag = null;
    rails.forEach(r => r.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; drag = { r, x: e.clientX, s: r.scrollLeft, m: false }; }));
    addEventListener('pointermove', e => { if (!drag) return; const dx = e.clientX - drag.x; if (Math.abs(dx) > 4) { drag.m = true; drag.r.style.scrollSnapType = 'none'; drag.r.scrollLeft = drag.s - dx; } });
    addEventListener('pointerup', () => { if (!drag) return; drag.r.style.scrollSnapType = ''; if (drag.m) drag.r.addEventListener('click', ev => { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true }); drag = null; });

    const tabs = root.querySelector('.tabs'), pill = root.querySelector('.tabs__pill');
    function movePill(b) { if (!pill || !b) return; pill.style.width = b.offsetWidth + 'px'; pill.style.transform = `translateX(${b.offsetLeft}px)`; }
    function select(b) {
      if (!tabs) return;
      tabs.querySelectorAll('button').forEach(x => x.setAttribute('aria-selected', x === b));
      movePill(b);
      rails.forEach(r => r.hidden = r.id !== b.getAttribute('aria-controls'));
      rail = rails.find(r => !r.hidden);
      rail.scrollLeft = 0; rail.classList.remove('is-swap'); void rail.offsetWidth; rail.classList.add('is-swap'); updRail();
    }
    if (tabs) {
      tabs.querySelectorAll('button').forEach(b => b.addEventListener('click', () => select(b)));
      requestAnimationFrame(() => movePill(tabs.querySelector('[aria-selected="true"]')));
      addEventListener('resize', () => movePill(tabs.querySelector('[aria-selected="true"]')));
    }
    root._khSelect = i => { const b = tabs && tabs.querySelectorAll('button')[i]; if (b) select(b); };
    updRail();

    const qvd = root.querySelector('dialog.qvd');
    if (!qvd) return;
    const q = s => qvd.querySelector(s);
    root.addEventListener('click', e => {
      const b = e.target.closest('.qv'); if (!b) return;
      const d = b.dataset;
      q('[data-qv-img]').src = d.img; q('[data-qv-img]').alt = d.title;
      q('[data-qv-cat]').textContent = d.cat; q('[data-qv-name]').textContent = d.title;
      q('[data-qv-full]').textContent = d.desc || '';
      const card = b.closest('.card');
      q('[data-qv-price]').innerHTML = card.querySelector('.price').innerHTML + (d.save ? `<span class="save" style="position:static">Save ${d.save}%</span>` : '');
      q('[data-qv-sw]').innerHTML = +d.colors > 1 ? `<i></i>Available in ${d.colors} colors` : '';
      q('[data-qv-link]').href = d.url;
      try { qvd.showModal(); } catch (err) { qvd.setAttribute('open', ''); }
    });
    q('[data-qv-close]').onclick = () => qvd.close();
    qvd.addEventListener('click', e => { if (e.target === qvd) qvd.close(); });
  }

  /* Video play/pause */
  function initFilm(film) {
    const vid = film.querySelector('video'), vt = film.querySelector('.film__toggle');
    if (!vid || !vt) return;
    const vi = vt.querySelector('svg');
    const PAUSE = '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>', PLAY = '<path d="M8 5.5v13l11-6.5z"/>';
    vt.onclick = () => {
      if (vid.paused) { vid.play(); vi.innerHTML = PAUSE; vt.setAttribute('aria-label', 'Pause video'); }
      else { vid.pause(); vi.innerHTML = PLAY; vt.setAttribute('aria-label', 'Play video'); }
    };
    if (reduce) { vid.removeAttribute('autoplay'); vid.pause(); vi.innerHTML = PLAY; vt.setAttribute('aria-label', 'Play video'); }
  }

  /* Scroll effects: parallax on look image, zoom on film and feature image */
  let ticking = false;
  function onScroll() {
    ticking = false; if (reduce) return; const vh = innerHeight;
    document.querySelectorAll('.kh .look__media img').forEach(img => { const r = img.getBoundingClientRect(); if (r.bottom > 0 && r.top < vh) { const p = (r.top + r.height / 2 - vh / 2) / vh; img.style.setProperty('--py', (p * -28).toFixed(1) + 'px'); } });
    document.querySelectorAll('.kh .film').forEach(f => { const r = f.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) { const p = Math.min(1, Math.max(0, (vh - r.top) / (vh * .85))); f.style.setProperty('--vs', (0.94 + 0.06 * p).toFixed(4)); } });
    document.querySelectorAll('.kh .feature__media img').forEach(img => { const r = img.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) { const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height))); img.style.setProperty('--fs', (1.1 - 0.1 * p).toFixed(4)); } });
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* Reveal on scroll (skipped in the theme editor so content is always visible) */
  const io = !reduce && !window.Shopify?.designMode && 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.remove('pre'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' })
    : null;

  function init(scope) {
    scope.querySelectorAll('[data-kh="hero"]').forEach(initHero);
    scope.querySelectorAll('[data-kh="products"]').forEach(initProducts);
    scope.querySelectorAll('[data-kh="film"]').forEach(initFilm);
    if (io) scope.querySelectorAll('.kh .rv').forEach(el => { if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('pre'); io.observe(el); } });
    onScroll();
  }

  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('.kh dialog.qvd[open]').forEach(d => d.close()); });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const blk = e.target, hero = blk.closest('[data-kh="hero"]'), prod = blk.closest('[data-kh="products"]');
    if (hero && hero._khGo) hero._khGo(+blk.dataset.index || 0);
    if (prod && prod._khSelect && blk.dataset.index) prod._khSelect(+blk.dataset.index);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
})();
